import ActionModelCommon from 'common/models/action';

export default class ActionModel extends ActionModelCommon {}
